import { SparklesIcon } from "../../../../../assets";
import "./index.scss";

interface ChatIaAnimatedButtonProps {
  onClick?: () => void;
  label?: string;
}

export function ChatIaAnimatedButton({
  onClick,
  label = "LEX IA",
}: ChatIaAnimatedButtonProps) {
  return (
    <button className="pdl_ia_animated_button" onClick={onClick}>
      <span className="border"></span>
      <span className="content">
        <SparklesIcon className="icon" />
        <span className="text">{label}</span>
      </span>
    </button>
  );
}
